import {Box, Button, Center, Field, Input, Stack, VStack} from "@chakra-ui/react";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useRecoilState} from "recoil";
import {showTfaCheck, userData} from "../../components/hooks/recoilData";
import {useToast} from "@chakra-ui/toast";
import {userApi} from "../../api/user-api";

interface SecurityParams {
    login: string,
    password: string,
    password2: string,
    email: string,
    tel: string,
}

export const Security = () => {
    const inputDefault: SecurityParams = useMemo(() => {
        return {
            login: "",
            password: "",
            password2: "",
            email: "",
            tel: "",
        }
    }, []);
    const [inputParams, setInputParams] = useState<SecurityParams>(inputDefault);
    const toast = useToast();
    const [user, setUser] = useRecoilState(userData);
    const [, setTfa] = useRecoilState(showTfaCheck);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setInputParams({
                login: user.LOGIN ? user.LOGIN : "",
                password: "",
                password2: "",
                email: user.EMAIL ? user.EMAIL : "",
                tel: user.TEL ? user.TEL : "",
            });
        }
    }, [user]);
    const changePassword = useCallback(() => {
        if (inputParams.password !== inputParams.password2) {
            toast({title: "Change error", description: `password not match`, status: "error"});
            return
        }
        userApi.changePassword(inputParams.password)
            .then((o) => {
                setLoading(false);
                if (o) {
                    toast({title: "Save", status: "success"})
                } else {
                    toast({title: "Save failed", status: "error"});
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("Error status code is: " + err)
                toast({title: "Error", description: `code: [${err}]`, status: "error"});
            });
        setLoading(true);
    }, [inputParams, toast]);

    const changeEmail = useCallback(() => {
        userApi.changeEmail(inputParams.email)
            .then((o) => {
                setTfa(false);
                setLoading(false);
                if (o) {
                    toast({title: "Save", status: "success"});
                    userApi.userOwnGet()
                        .then(o2 => setUser(o2))
                        .catch((err) => {
                            console.log("Error status code is: " + err);
                        });
                } else {
                    toast({title: "Save failed", status: "error"});
                }
            })
            .catch((err) => {
                setTfa(false);
                setLoading(false);
                console.log("Error status code is: " + err)
                toast({title: "Error", description: `code: [${err}]`, status: "error"});
            });
        setTfa(true);
        setLoading(true);
    }, [inputParams.email, setTfa, setUser, toast]);

    const changeTel = useCallback(() => {
        userApi.changeTel(inputParams.tel)
            .then((o) => {
                setTfa(false);
                setLoading(false);
                if (o) {
                    toast({title: "Save", status: "success"});
                    userApi.userOwnGet()
                        .then(o2 => setUser(o2))
                        .catch((err) => {
                            console.log("Error status code is: " + err);
                        });
                } else {
                    toast({title: "Save failed", status: "error"});
                }
            })
            .catch((err) => {
                setTfa(false);
                setLoading(false);
                console.log("Error status code is: " + err)
                toast({title: "Error", description: `code: [${err}]`, status: "error"});
            });
        setTfa(true);
        setLoading(true);
    }, [inputParams.tel, setTfa, setUser, toast]);

    return (
        <VStack>
            <Center>{user?.ID}</Center>
            <Box borderWidth={1} borderColor="gray">
                <Stack>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Пароль <Field.RequiredIndicator/></Field.Label>
                        <Input type="password" placeholder="Пароль" value={inputParams.password}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, password: it.target.value}
                               })}
                        />
                    </Field.Root>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Пароль 2 <Field.RequiredIndicator/></Field.Label>
                        <Input type="password" placeholder="Пароль 2" value={inputParams.password2}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, password2: it.target.value}
                               })}
                        />
                    </Field.Root>
                    <Button borderRadius={0} variant="solid" colorScheme="teal" width="full" loading={loading} onClick={changePassword}>
                        Изменить
                    </Button>
                </Stack>
            </Box>
            <Box borderWidth={1} borderColor="gray">
                <Stack>
                    <Field.Root orientation="horizontal" required>
                            <Field.Label>Почта <Field.RequiredIndicator/></Field.Label>
                        <Input type="email" placeholder="Почта" value={inputParams.email}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, email: it.target.value}
                               })}/>
                    </Field.Root>
                    <Button borderRadius={0} variant="solid" colorScheme="teal" width="full" loading={loading} onClick={changeEmail}>
                        Изменить
                    </Button>
                </Stack>
            </Box>
            <Box borderWidth={1} borderColor="gray">
                <Stack>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Телефон <Field.RequiredIndicator/></Field.Label>
                        <Input type="tel" placeholder="Телефон" value={inputParams.tel}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, tel: it.target.value}
                               })}/>
                    </Field.Root>
                    <Button borderRadius={0} variant="solid" colorScheme="teal" width="full" loading={loading} onClick={changeTel}>
                        Изменить
                    </Button>
                </Stack>
            </Box>
        </VStack>
    );
};